<template>
	<div class="col-sm-12">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		computed: {
			
		}
	}
</script>


// WEBPACK FOOTER //
// MealPlans.vue?3cee5ee8